module.exports = __webpack_public_path__ + "img/xmasParty3.ded1241b.jpg";